import React, { useState, useEffect } from "react";

const CustomPagination = ({
  current,
  total,
  pageSize,
  onPageChange,
  onPageSizeChange,
}) => {
  const [inputValue, setInputValue] = useState(pageSize.toString());
  const predefinedSizes = [10, 20, 30, 50, 100];

  const totalPages = Math.ceil(total / pageSize);

  useEffect(() => {
    setInputValue(pageSize.toString());
  }, [pageSize]);

  const handlePrevious = () => {
    if (current > 1) onPageChange(current - 1);
  };

  const handleNext = () => {
    if (current < totalPages) onPageChange(current + 1);
  };

  return (
    <div className="d-flex justify-content-end gap-3 mt-3">
      <nav>
        <ul className="pagination mb-0">
          <li className={`page-item ${current === 1 ? "disabled" : ""}`}>
            <button className="page-link" onClick={handlePrevious}>
              &lt;
            </button>
          </li>
          <li className="page-item active">
            <span className="page-link">{current}</span>
          </li>
          <li
            className={`page-item ${current === totalPages ? "disabled" : ""}`}
          >
            <button className="page-link" onClick={handleNext}>
              &gt;
            </button>
          </li>
        </ul>
      </nav>

      <div className="btn-group">
        <button
          className="btn btn-outline-primary btn-sm dropdown-toggle border border-primary "
          type="button"
          id="pageSizeDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {pageSize} / page
        </button>
        <ul className="dropdown-menu" aria-labelledby="pageSizeDropdown">
          {predefinedSizes.map((size) => (
            <li key={size}>
              <button
                className={`dropdown-item ${size === pageSize ? "active" : ""}`}
                onClick={() => onPageSizeChange(size)}
              >
                {size} / page
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CustomPagination;
